var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hl-group-box", class: {} }, [
    _vm.video.allVideos.length && !_vm.noPpatt
      ? _c("div", { staticClass: "group-details" }, [
          _vm._v(
            "\n    This subscription includes access to " +
              _vm._s(_vm.video.allVideos.length) +
              " videos\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vid-subsc-box" },
      [
        _vm.noPpatt
          ? [
              _c("div", { staticClass: "option option-one" }, [
                _c("p", [
                  _vm._v(
                    "this " +
                      _vm._s(_vm.introPhotoUrl ? "content" : "video") +
                      " is available only to PPATT members"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "buy-btn buy-btn-one",
                    attrs: { href: "" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [_vm._v("Request access")]
                )
              ])
            ]
          : [
              _vm.video.priceUsd * 1
                ? _c("div", { staticClass: "option" }, [
                    _c("p", [
                      _vm._v("1 day for "),
                      _c("em", [
                        _vm._v(_vm._s(_vm.formatPriceP(_vm.video.priceUsd)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "buy-btn",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectVid(0)
                          }
                        }
                      },
                      [_vm._v("Subscribe")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.video.price1 * 1
                ? _c("div", { staticClass: "option" }, [
                    _c("p", [
                      _vm._v("3 days for "),
                      _c("em", [
                        _vm._v(_vm._s(_vm.formatPriceP(_vm.video.price1)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "buy-btn",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectVid(1)
                          }
                        }
                      },
                      [_vm._v("Subscribe")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.video.price2 * 1
                ? _c("div", { staticClass: "option" }, [
                    _c("p", [
                      _vm._v("7 days for "),
                      _c("em", [
                        _vm._v(_vm._s(_vm.formatPriceP(_vm.video.price2)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "buy-btn",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectVid(2)
                          }
                        }
                      },
                      [_vm._v("Subscribe")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.video.price3 * 1
                ? _c("div", { staticClass: "option" }, [
                    _c("p", [
                      _vm._v("30 days for "),
                      _c("em", [
                        _vm._v(_vm._s(_vm.formatPriceP(_vm.video.price3)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "buy-btn",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectVid(3)
                          }
                        }
                      },
                      [_vm._v("Subscribe")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.video.price4 * 1
                ? _c("div", { staticClass: "option" }, [
                    _c("p", [
                      _vm._v("90 days for "),
                      _c("em", [
                        _vm._v(_vm._s(_vm.formatPriceP(_vm.video.price4)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "buy-btn",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectVid(4)
                          }
                        }
                      },
                      [_vm._v("Subscribe")]
                    )
                  ])
                : _vm._e()
            ]
      ],
      2
    ),
    _vm._v(" "),
    !_vm.noPpatt ? _c("div", { staticClass: "or" }, [_vm._v("or")]) : _vm._e(),
    _vm._v(" "),
    !_vm.noPpatt
      ? _c(
          "div",
          { staticClass: "pkg-subsc-box" },
          [
            _c("p", { staticClass: "msg" }, [
              _vm._v(
                "subscribe to a package that includes all " +
                  _vm._s(_vm.video.type.title) +
                  " videos"
              )
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "buy-btn",
                attrs: { to: { name: "packages" } },
                nativeOn: {
                  click: function($event) {
                    return _vm.goToSubscribe($event)
                  }
                }
              },
              [_vm._v("Subscribe")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }